import { NavLink } from 'components/Nav';

import classes from './style.module.css';

const navLinkClassName = ({ isActive }: { isActive: boolean; }) => {
  return `${classes.sectionListItem} ${isActive ? classes.sectionListItemActive : ''}`;
};

type SectionListNavLinkProps = {
  to: string;
  label: string;
  iconSvg?: React.ReactNode;
};

/**
 * sidebar section nav link that must go inside a list <ul>
 * @param param0
 * @returns
 */
export const SectionListNavLink = ({ to, label, iconSvg }: SectionListNavLinkProps) => (
  <NavLink to={to} className={navLinkClassName}>
    <li key={label} className={classes.listItem}>
      {iconSvg && iconSvg}
      <span>{label}</span>
    </li>
  </NavLink>
);
